import {Component, Input, OnInit} from '@angular/core';
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {forkJoin, merge} from "rxjs";
import {Category} from "../../models/category";
import {CategoryService} from "../../services/category/category.service";
import {CategoryModal} from "../../modals/category-modal/category-modal.component";
import {MessagesService} from "../../services/messages/messages.service";
import {ArtworkService} from "../../services/artwork/artwork.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.scss']
})
export class CategoriesComponent implements OnInit {

  @Input() projectId: string;
  @Input() databaseId: string;

  categories: Array<Category> = [];

  constructor(
    private modalService: NgbModal,
    private artworkService: ArtworkService,
    private categoryService: CategoryService,
    private messagesService: MessagesService,
    private router: Router,
  ) {
  }

  ngOnInit() {
    merge(
      this.categoryService.getAllMyCategories(this.projectId, this.databaseId),
      this.categoryService.onChange
    ).subscribe(
      () => this.categories = this.categoryService.categories.sort((a, b) => a.order - b.order),
      err => this.messagesService.errorToast(err));
  }

  onShowModal() {
    const modalRef = this.modalService.open(CategoryModal, {size: 'lg'});
    modalRef.componentInstance.projectId = this.projectId;
    modalRef.componentInstance.databaseId = this.databaseId;
    modalRef.componentInstance.categoriesLength = this.categories.length;
  }

  onDelete(categoryId) {
    this.messagesService.confirmModal().result
      .then(
        result => {
          if (result) {
            this.categoryService.deleteCategory(this.projectId, this.databaseId, categoryId)
              .subscribe(
                () => {
                  this.messagesService.successToast('Category deleted.')
                  this.router.navigateByUrl('projects/' + this.projectId + '/databases/' + this.databaseId);
                },
                err => this.messagesService.errorToast(err)
              );
          }
        })
      .catch(() => {
      });
  }

  onSwitchOrder(cat1, cat2) {
    const tmp = cat1.order;

    cat1.order = cat2.order;
    cat2.order = tmp;

    forkJoin(
      this.categoryService.patchCategory(this.projectId, this.databaseId, cat1._id, new Category(cat1)),
      this.categoryService.patchCategory(this.projectId, this.databaseId, cat2._id, new Category(cat2))
    )
      .subscribe(
        () => this.messagesService.successToast('Categories updated.'),
        err => this.messagesService.errorToast(err),
      );
  }

  onTogglePreferred(category: Category) {
    category = new Category(category);

    category.preferred = !category.preferred;

    this.categoryService.patchCategory(this.projectId, this.databaseId, category._id, category)
      .subscribe(
        () => this.messagesService.successToast((category.preferred ? 'Added Category to' : 'Removed Category from') + ' preferred list'),
        err => this.messagesService.errorToast(err)
      );
  }
}
